class VideoCallSocketService {
    constructor() {
        if (new.target === VideoCallSocketService) {
            throw new Error("Cannot instantiate an abstract class.");
        }
        if (this.connect === VideoCallSocketService.prototype.connect) {
            throw new Error("Class extending VideoCallSocketService must override 'connect(data)'.");
        }
        if (this.disconnect === VideoCallSocketService.prototype.disconnect) {
            throw new Error("Class extending VideoCallSocketService must override 'disconnect()'.");
        }

        // if(this)
    }

    connect(data) {
        throw new Error("Method 'connect(data)' must be implemented.");
    }

    disconnect() {
        throw new Error("Method 'disconnect()' must be implemented.");
    }
}

export default VideoCallSocketService;